import { atom } from 'jotai'

export type ImageUploadCallback = (files: FileList) => void
export type QuickImageUploadCallback = (
	file: File,
	onComplete: (uuid: string, url: string) => void,
	onError?: () => void,
) => void
export type QuickImageGenerateCallback = (
	prompt: string,
	onComplete: (uuid: string) => void,
	onError?: (message: string) => void,
) => void

// Atoms to hold image callback functions
export const imageUploadCallbackAtom = atom<ImageUploadCallback | null>(null)
export const quickImageUploadCallbackAtom = atom<QuickImageUploadCallback | null>(null)
export const quickImageGenerateCallbackAtom = atom<QuickImageGenerateCallback | null>(null)
